var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ax-workspace-icon"},[_c('AxIcon',{attrs:{"name":_vm.iconName}}),(false)?_c('AxIcon',{staticClass:"ax-workspace-users-icon",attrs:{"name":"users"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }